<template>
  <div>
    <div class="d-flex">
      <h2 class="titleText--text">
      Sales volume given by each variable over the period
    </h2>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon  v-bind="attrs" size="medium"
              v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
            </template>
            <span> Sales volume given by each variable over the period</span>
          </v-tooltip>
        </div>
    <v-card flat class="custom-shadow mt-2">
      <v-card-text>
        <div v-if="!chartshow" class="d-flex justify-center"><v-progress-circular color="blue" size="50" indeterminate /></div>
        <div id="chart" v-else>
          <apexchart
            type="area"
            height="350"
            ref="chart"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { bus } from "../../../main";
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import apifactorynew from "../api";

Vue.use(VueAxios, axios);
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    datalist: [],
    sumofspend: 0,
    //for chart
    itemsplot: [],
    series: [],
    chartshow: 0,
    chartOptions: {
      chart: {
        id: "area-datetime",
        stacked: true,
        height: 350,
        zoom: {
          autoScaleYaxis: true,
        },
        fontFamily: "Lato",
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },

      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      legend: {
        show: true,
      },
      stroke: {
        width: [0, 0, 0],
        curve: "smooth",
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      grid: {
        show: false, // you can either change hear to disable all grids
        xaxis: {
          lines: {
            show: false, //or just here to disable only x axis grids
          },
        },
        yaxis: {
          lines: {
            show: false, //or just here to disable only y axis
          },
        },
      },
    },

    xaxismin: null,
    xaxismax: null,
    //end for chart
  }),

  methods: {
    getplot() {
      apifactorynew
        .api_get_model_actual_predicted()
        .then((res) => {
          if (res.status != 200) {
            this.itemsplot = null;
            // alert(this.processdataitems.length);
          } else {
            let tempdata = [];
            tempdata = res.data.volume_area_chart;
            // this.datalist= res.data.volume_area_chart;

            //alert(JSON.stringify(tempdata));
            this.itemsplot = tempdata.filter((a) => a.region == "national");
            // this.itemsplot = res.data.volume_area_chart;
            // alert(JSON.stringify( this.itemsplot ));
            this.getchartseries();
            //this.getnewdata();
            //this.getnewdataapicall();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "date" && k1 != "region") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].date).getTime());
            var innerdata = [];
            //innerdata.push(k1);
            // let newval=new Date(this.itemsplot[i].t_date).getTime() + "," + this.itemsplot[i][k1];

            innerdata.push(new Date(this.itemsplot[i].date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;
      this.series = [];
      this.series = tkey;

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      //alert(mindate);

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            type: "datetime",
            min: mindate,
            max: maxdate,
            tickAmount: 6,
            labels: {
              style: {
                colors: "#9AA1A9",
                fontWeight: "bold",
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: ["#9AA1A9"],
              },
            },
          },
          annotations: {
            yaxis: [
              {
                y: 0,
                borderColor: "#999",
                label: {
                  show: true,
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#00E396",
                  },
                },
              },
            ],
            xaxis: [
              {
                x: mindate,
                borderColor: "#999",
                yAxisIndex: 0,

                label: {
                  show: true,
                  formatter: function (val) {
                    return "YY-" + val;
                  },
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#775DD0",
                  },
                },
              },
            ],
          },
        },
      };
      this.chartshow = 1;
    },
    Refresh() {
      //alert("refreshmodelAreaChart1111MMMMM");
      this.getplot();
    },
    getnewdata() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "date" && k1 != "region") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].date).getTime());
            var innerdata = [];
            //innerdata.push(k1);
            // let newval=new Date(this.itemsplot[i].t_date).getTime() + "," + this.itemsplot[i][k1];

            //innerdata.push(new Date(this.itemsplot[i].date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;

      this.datalist = [];
      for (let index = 0; index < tkey.length; index++) {
        if (tkey[index].name != "base") {
          //this.datalist.push(tkey[i].name);
          var objnew = new Object();
          objnew.ROI = Math.ceil(Math.random() * 100.0);
          objnew.name = tkey[index].name;
          objnew.SpendValue = Math.ceil(Math.random() * 100.0);
          objnew.SpendPer = objnew.SpendValue; // Math.ceil(Math.random() * 100.0);
          objnew.IncrValue = Math.ceil(Math.random() * 100.0);
          objnew.IncPer = objnew.IncrValue; //Math.ceil(Math.random() * 100.0);
          this.datalist.push(objnew);
        }
        // this.datalist.push(tkey[index].name);
      }
      //this.datalist = [];
      //this.datalist=tkey;
    },
 
  },
  mounted() {
    this.getplot();
    bus.$off("refreshmodelAreaChart");
    bus.$on("refreshmodelAreaChart", this.Refresh);
  },
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}

.selectedbtn {
  background-color: #0177b2 !important;
  color: white !important;
}

.nonselectedbtn {
  background-color: lightgrey !important;
  color: black !important;
  /* opacity: 40%;*/
}

.errorlog {
  background-color: rgba(255, 0, 0, 0.274);
  color: black;
}

.nonerrorlog {
  background-color: rgba(0, 128, 0, 0.377);
  color: black;
}

</style>
